import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = { class: "sms-modal-test__form" };
const _hoisted_3 = { class: "sms-modal-test__form-field" };
const _hoisted_4 = { for: "phone" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "*", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "sms-modal-test__form-field--prefix" }, "+55", -1);
const _hoisted_7 = {
    key: 0,
    class: "sms-modal-test__form-field--error-text"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "sms-modal-test__form-field" };
const _hoisted_10 = { for: "message" };
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "dialog" };
import { ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { sendSmsTest } from '@/features/SMSCampaigns/data';
import { useSmsBalance } from '@/features/SMSCampaigns/composables/useSmsBalance';
import { mixpanelSmsCampaign } from '@/utilities/mixpanel/smsCampaigns';
import i18n from '@/i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SMSCampaignsModalTest',
    props: {
        isVisible: { type: Boolean }
    },
    emits: ['closeModal'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const { updateBalance } = useSmsBalance();
        const { t } = i18n.global;
        const toast = useToast();
        const store = useStore();
        const loading = ref(false);
        const phone = reactive({
            number: '',
            hasError: false,
        });
        const message = computed(() => store.getters['smsCampaigns/getMessage'][0].message);
        const isValidPhone = computed(() => {
            const REQUIRED_PHONE_LENGTH = 11;
            const digitsOnly = phone.number.replace(/\D/g, '');
            return String(digitsOnly).length === REQUIRED_PHONE_LENGTH;
        });
        const closeModal = () => {
            emits('closeModal');
        };
        const send = () => {
            mixpanelSmsCampaign.sendSmsTest(message.value, phone.number);
            if (!isValidPhone.value) {
                phone.hasError = true;
                return;
            }
            loading.value = true;
            const mobileNumber = '55' + phone.number.replace(/\s+/g, '');
            sendSmsTest(mobileNumber, message.value)
                .then(isSuccessful => {
                if (isSuccessful) {
                    toast.success(t('sms-campaigns.test-sms.toast-success'), { timeout: 3000 });
                    closeModal();
                }
                else {
                    toast.error(t('sms-campaigns.test-sms.toast-error'), { timeout: 3000 });
                }
            })
                .finally(() => {
                updateBalance();
                phone.hasError = false;
                phone.number = '';
                loading.value = false;
            });
        };
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            const _directive_mask = _resolveDirective("mask");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                onClose: closeModal,
                "model-value": props.isVisible,
                title: _ctx.$tc('sms-campaigns.test-sms.title'),
                class: "sms-modal-test",
                width: "480",
                "append-to-body": ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("p", {
                        innerHTML: _ctx.$t('sms-campaigns.test-sms.description'),
                        class: "sms-modal-test__description"
                    }, null, 8, _hoisted_1),
                    _createElementVNode("form", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("label", _hoisted_4, [
                                _createTextVNode(_toDisplayString(_ctx.$t('sms-campaigns.test-sms.fields.phone-label')) + " ", 1),
                                _hoisted_5
                            ]),
                            _hoisted_6,
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((phone.number) = $event)),
                                onInput: _cache[1] || (_cache[1] = ($event) => (phone.hasError = false)),
                                class: _normalizeClass({ 'sms-modal-test__form-field--error-input': phone.hasError }),
                                placeholder: "99 999999999",
                                maxlength: "16",
                                type: "text",
                                id: "phone",
                                name: "phone"
                            }, null, 34), [
                                [_vModelText, phone.number],
                                [_directive_mask, ['## #########']]
                            ]),
                            _createVNode(_Transition, { name: "error-fade" }, {
                                default: _withCtx(() => [
                                    (phone.hasError)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                            _createElementVNode("img", {
                                                src: require(`@/assets/svgs/red-alert-icon.svg`)
                                            }, null, 8, _hoisted_8),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('sms-campaigns.test-sms.fields.invalid-phone')), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('_message')), 1),
                            _createElementVNode("textarea", {
                                value: message.value,
                                name: "message",
                                id: "message",
                                cols: "30",
                                rows: "3",
                                disabled: ""
                            }, null, 8, _hoisted_11)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_el_button, {
                            class: "btn btn-outline-ctx-primary",
                            round: "",
                            onClick: closeModal
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$tc('_cancel', 2)), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_button, {
                            class: "btn btn-primary",
                            onClick: send,
                            round: "",
                            loading: loading.value
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$tc('_send', 2)), 1)
                            ]),
                            _: 1
                        }, 8, ["loading"])
                    ])
                ]),
                _: 1
            }, 8, ["model-value", "title"]));
        };
    }
});
